module.exports = __webpack_public_path__ + "static/media/Raffrollo_35627_120x160.4923254a.png";